import React from "react";
import { Col, Form } from "antd";
import styles from "./formItem.scss";
import { getWindowWidth, isSearchMobile } from "../../../../../../services";
import { resolveValidationRule } from "./ValidationRuleResolver";
import { ControlType, DataSource } from "../../../../../../models";

// eslint-disable-next-line complexity
function FormItem(props) {
  // TODO: need to use onError for now because we dont have enough time to fix mutate of props
  // in multi level level
  const { controlData, fullWidth, form, children, errors } = props;
  const { id, defaultValue, data } = controlData;
  let colStyle;
  const isMobile = isSearchMobile(getWindowWidth());
  if (isMobile) {
    colStyle = styles.controlColMobile;
  } else {
    colStyle = !fullWidth ? styles.controlCol : undefined;
  }

  const tyresFields = [
    "summerTyres",
    "winterTyres",
    "allSeasonTyres"
  ]

  const isInputTextList = controlData.type == ControlType.inputTextList;


  return (
    <Col
      key={id}
      xs={tyresFields.includes(controlData.field) ? 22 : 24}
      // InputTextList needs the full form width so the trash icon can
      // float into the group container's right padding (Tyres pattern).
      // With sm={12} the icon would overflow into the next column.
      sm={isInputTextList ? 24 : (!fullWidth && !isMobile ? 12 : undefined)}
      className={colStyle}
      style={{
        padding: `${(controlData.type == ControlType.multiFieldSelectorCb &&
            controlData.options.length > 1) ||
            controlData.dataSource == DataSource.make
            ? "0px"
            : ""
          }`,
        marginBottom: `${controlData.dataSource == DataSource.make || controlData.marginBottom
            ? "20px"
            : ""
          }`
      }}
    >
      <Form.Item
        style={{ marginBottom: "20px" }}
        validateStatus={isInputTextList ? "" : undefined}
        help={isInputTextList ? null : undefined}
      >
        {form.getFieldDecorator(id, {
          rules: resolveValidationRule(controlData, errors),
          initialValue: data || defaultValue
        })(children)}
      </Form.Item>
    </Col>
  );
}

export default FormItem;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/GroupControls/Control/FormItem/index.tsx